export enum VehicleStateEnum {

  ACTUAL_MILEAGE = 'actualMileage',
  AVG_MILEAGE_PER_YEAR = 'avgMileagePerYear',
  VEHICLE_CONDITION = 'vehicleCondition',
  IS_VALID_CAR_INSPECTION = 'isValidCarInspection',
  IS_LEASING = 'isLeasing',
  COUNTRY_OF_ORIGIN = 'countryOfOrigin',
  IS_ABROAD = 'isAbroad',
  PARKING_PLACE = 'parkingPlace',
  DAMAGE_DESCRIPTION = 'damageDescription',
  USAGE_TYPE = 'usageType',
  ABROAD_IMPORTED = 'abroadImported',
  ABROAD_IMPORTED_TIME = 'abroadImportedTime',
  PURCHASE_YEAR = 'purchaseYear',
  PURCHASE_MONTH = 'purchaseMonth',
}
